var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dropdown-menu",
      class: { mobileCart: _vm.UiService.isMobileView },
      attrs: { id: "sideCart" },
    },
    [
      _c("top-cart"),
      _vm._v(" "),
      _c("div", { staticClass: "topBgCart" }, [
        _c("div", { staticClass: "BgCart" }, [
          _c("div", { staticClass: "cartContentBox" }, [
            _c(
              "ul",
              {
                ref: "simple",
                staticClass: "d-flex flex-column",
                attrs: { id: "cartContent" },
              },
              [
                _c(
                  "div",
                  [
                    _c("cart-salearea", {
                      attrs: {
                        order: _vm.cart,
                        address: _vm.cart && _vm.cart.address,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cart && _vm.cart.oi.length < 1,
                        expression: "cart && cart.oi.length < 1",
                      },
                    ],
                    staticClass: "emptyCartMessage",
                  },
                  [
                    _c("span", [
                      _vm._v("Vous n'avez encore rien ajouté à votre panier."),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Commencez par choisir vos plats préférés."),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "cartItemContainer" },
                  _vm._l(_vm.cart && _vm.cart.oi, function (item) {
                    return _c("cart-item-component", {
                      key: _vm.key(item),
                      attrs: {
                        item: item,
                        "hide-prices":
                          _vm.ShopService.shop &&
                          _vm.ShopService.shop.info &&
                          _vm.ShopService.shop.info.hidePrices,
                      },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.ShopService.shop &&
                _vm.ShopService.shop.info.upsell.suggestions.displayInCart &&
                _vm.UpsellService.getSuggestions().length
                  ? _c(
                      "div",
                      { staticClass: "mt-auto" },
                      [
                        _c("div", { staticClass: "text-center" }, [
                          _vm._v(
                            _vm._s(_vm.UpsellService.getSuggestionsProduct().dn)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "carousel2",
                          { attrs: { "per-page": 2, "pagination-padding": 5 } },
                          _vm._l(
                            _vm.UpsellService.getSuggestions(),
                            function (suggestion, i) {
                              return _c(
                                "slide2",
                                { key: i },
                                [
                                  _c("item-child-list", {
                                    attrs: {
                                      item: suggestion,
                                      cart: _vm.cart,
                                      shop: _vm.ShopService.shop,
                                      "in-cart": true,
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.cart
              ? _c(
                  "div",
                  {
                    staticClass:
                      "bottomCart d-flex flex-column justify-content-center align-items-center",
                    attrs: { id: "totalCart" },
                  },
                  [
                    _vm.cart.promo_code
                      ? _c(
                          "div",
                          { staticClass: "total flex-between-end color-bo-p2" },
                          [
                            !_vm.cart.promo_code
                              ? _c("div", [_vm._v("Remise")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cart.promo_code
                              ? _c("div", [
                                  _vm._v(_vm._s(_vm.cart.DiscountName)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.ShopService.prix(_vm.cart.Discount))
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "total" }, [
                      _c("span", { staticClass: "totalTitle" }, [
                        _vm._v("Total:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "totalPrice" }, [
                        _vm._v(_vm._s(_vm.ShopService.prix(_vm.cart.Total))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "eatbtn eatbtn-default",
                        staticStyle: { width: "300px" },
                        attrs: { "data-cy": "open-checkout" },
                        on: {
                          click: function ($event) {
                            return _vm.openCheckoutModal()
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t\tCommander\n\t\t\t\t\t")]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }